// Maps visually similar Cyrillic ↔ Latin characters to a common canonical form
const LOOKALIKE: Record<string, string> = {
  // Cyrillic → Latin canonical
  "а": "a", "е": "e", "о": "o", "р": "p", "с": "c", "х": "x", "у": "y",
  "А": "a", "Е": "e", "О": "o", "Р": "p", "С": "c", "Х": "x", "У": "y",
  "В": "b", "М": "m", "Н": "h", "К": "k", "Т": "t",
  "в": "b", "м": "m", "н": "h", "к": "k", "т": "t",
  // Latin uppercase → lowercase (handled by toLowerCase anyway, belt+suspenders)
};

export function normalizeQuery(s: string): string {
  return s
    .trim()
    .toLowerCase()
    .split("")
    .map(c => LOOKALIKE[c] ?? c)
    .join("");
}

export function matchesSearch(query: string, ...targets: (string | null | undefined)[]): boolean {
  if (!query) return true;
  const q = normalizeQuery(query);
  if (!q) return true;
  return targets.some(t => t && normalizeQuery(t).includes(q));
}

export function createSearchMatcher(query: string): ((...targets: (string | null | undefined)[]) => boolean) {
  if (!query) return () => true;
  const q = normalizeQuery(query);
  if (!q) return () => true;
  return (...targets) => targets.some(t => t && normalizeQuery(t).includes(q));
}
